export const SET_CONVERSATIONS = 'SET_CONVERSATIONS';
export const SET_MESSAGES = 'SET_MESSAGES';
export const SET_SELECTED_CONVERSATION = 'SET_SELECTED_CONVERSATION';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const ADD_CONVERSATION = 'ADD_CONVERSATION';
